// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__18ZBZ","inputWrap":"styles_inputWrap__3ERGH","input":"styles_input__194EX"};